module.exports = __webpack_public_path__ + "static/media/Rectangle 12890.22f00da3.png";